export default __webpack_public_path__ + "img/how-to-use-slide01.b49b53d9.webp";